export const generateSlots = (duration, hours) => {
  if (!duration || !hours) return [];

  const slots = [];
  let start = hours.start * 60;
  const end = hours.end * 60;

  while (start + duration <= end) {
    const h1 = String(Math.floor(start / 60)).padStart(2, "0");
    const m1 = String(start % 60).padStart(2, "0");
    const h2 = String(Math.floor((start + duration) / 60)).padStart(2, "0");
    const m2 = String((start + duration) % 60).padStart(2, "0");
    slots.push(`${h1}:${m1} – ${h2}:${m2}`);
    start += duration;
  }

  return slots;
};
